"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const WCAGTextField_1 = tslib_1.__importDefault(require("./WCAGTextField"));
class WCAGPhoneNumberField extends WCAGTextField_1.default {
    isValidNextChar(currentValue, _char, _selectionStart = null, _selectionEnd = null) {
        return /^[ 0-9()+-]*$/.test(currentValue);
    }
    decorateLabeledStringFieldWidget(args) {
        super.decorateLabeledStringFieldWidget(args);
        this.fieldElement.type = "tel";
    }
}
exports.default = WCAGPhoneNumberField;
//# sourceMappingURL=WCAGPhoneNumberField.js.map